import { useEffect, useState } from "react";
import AdminSingleUserData from "./AdminSingleUserData";
import { handleData } from "../../api";

const AdminSettings = () => {

    const [users, setUsers] = useState([]);
    const [loadingMessage, setLoadingMessage] = useState('');

    const getUserData = async() => {
        const data = {
            method: 'GET',
            path: 'users'
        }
        setLoadingMessage('Data wordt geladen...');
        const result = await handleData(data);
        if (result.data.data) {
            setUsers(result.data.data);
            setLoadingMessage("");
        } else {
            setLoadingMessage("Er is iets misgegaan bij het laden van de data. Probeer het later nog eens.");
        }
    }

    useEffect(() => {
        getUserData();
    },[]);


    return (
        <>
            <div>
                <h2>Gebruiker toegang instellingen</h2>
                <p>Lijst met gebruikers:</p>
                <p>{loadingMessage}</p>

                <table>
                    <thead>
                        <tr>
                            <td>Naam</td>
                            <td>Gebruikersnaam</td>
                            <td>ContactPersoon</td>
                            <td>Admin</td>
                            <td>SuperAdmin</td>

                        </tr>
                    </thead>

                    <tbody>
                        {users && users.map(item => <AdminSingleUserData user={item} key={item._id}/> )}
                        
                        
                    </tbody>
                </table>
            </div>
        </>
    );
}



export default AdminSettings;